import { object, string, ref } from 'yup'

export const validationRecoveryPassword = (t) =>
  object({
    email: string()
      .email(t('login.error.email_format'))
      .required(t('login.error.required'))
      .transform((value) => value?.toLowerCase().trim()),
  })

export const validationNewPassword = (t) =>
  object({
    password: string()
      .required(t('login.error.required'))
      .min(8, t('login.error.password_length')),
    password_repeat: string()
      .required(t('login.error.required'))
      .oneOf([ref('password')], t('login.error.password_equals')),
  })
